<div class="add-noet-wrapper">
  <div class="container has-blur-white-bg">
    <h2 class="isbold">New Note</h2> 
    <form #form = 'ngForm' (ngSubmit)="onFormsubmit(form)">
      <div class="form-field">
        <input  ngModel required #titleField='ngModel' name="title" class="text-box" type="text" minlength="3" placeholder="Enter note title ...." >
        <ng-container *ngIf="titleField.invalid">
          <h4 *ngIf="titleField.errors!['required'] && titleField.touched || form.submitted ">this fild is required</h4>
          <h4 *ngIf="titleField.errors!['minlength']">title must be at least 3 characters</h4>
        </ng-container>
      </div>
      <div class="form-field">
        <textarea ngModel name="textarea" class="textarea"  placeholder="Enter note content ...."></textarea>
      </div>
      <div class="buttons">
        <a class="btn btn-secondary" routerLink="../">Cancel</a>
        <button  class="btn btn-prim">Create Note</button>
      </div>
    </form>
  </div>
</div>